import { Grid } from '@mui/material';
import { Drawer } from 'common/components/Drawer/Drawer';
import { BrandManager } from 'common/contact/common/components/Manager/BrandManager';
import { BrandSettingsManager } from 'common/contact/common/components/Manager/BrandSettingsManager';
import { CategoryManager } from 'common/contact/common/components/Manager/CategoryManager';
import { ContactManager } from 'common/contact/common/components/Manager/ContactManager';
import { NewOrderCheckManager } from 'common/contact/common/components/Manager/NewOrderCheckManager';
import { OrderManager } from 'common/contact/common/components/Manager/OrderManager';
import { PaymentManager } from 'common/contact/common/components/Manager/PaymentManager';
import { ProductManager } from 'common/contact/common/components/Manager/ProductManager';
import { useAppSelector } from 'common/context/hooks';
import { homeRoutes } from 'common/utils/routes';
import { CreateBrand } from './CreateBrand/CreateBrand';

export const App = () => {
  const brand = useAppSelector((state) => state.common.brand);
  const restorantCreating = useAppSelector(
    (state) => state.common.restorantCreating,
  );
  if (restorantCreating) return <CreateBrand />;

  return (
    <>
      <BrandManager />
      {brand && (
        <>
          <BrandSettingsManager />
          <ProductManager />
          <CategoryManager />
          <ContactManager />
          <PaymentManager />
          <OrderManager />
          <NewOrderCheckManager />
          <Grid
            className="admin"
            sx={{
              height: '100vh',
              overflow: 'hidden',
            }}
            container
          >
            <Drawer>
              <Grid sx={{ height: '100%;' }} direction="column" container>
                <Grid sx={{ flex: 1, height: '100%;' }} container>
                  {homeRoutes}
                </Grid>
              </Grid>
            </Drawer>
          </Grid>
        </>
      )}
    </>
  );
};
